import { render, staticRenderFns } from "./bayer-info.vue?vue&type=template&id=51222499&scoped=true"
import script from "./bayer-info.vue?vue&type=script&lang=js"
export * from "./bayer-info.vue?vue&type=script&lang=js"
import style0 from "./bayer-info.vue?vue&type=style&index=0&id=51222499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51222499",
  null
  
)

export default component.exports